/**
 * Various options for logging in
 */
export enum GALoginMethod {
    google = "Google",
    apple = "Apple",
    email = "Email",
    unknown = "Unknown"
}